import React from 'react';

import FilesList from '@components/common/FilesList';

import { IAssetFile } from '@interfaces/assets/asset';

import styles from './AssetParamInfo.module.scss';

interface IAssetParamInfoProps {
	info: string;
	files?: Array<IAssetFile>;
}

const AssetParamInfo = ({
	info,
	files = [],
}: IAssetParamInfoProps) => {

	return (
		<>
			<div className={styles.info}>{info}</div>
			{!!files?.length
				&& <div className={styles.wrapper}>
					<div className={styles.title}>Attached files</div>
					<FilesList
						files={files}
						isViewMode
						maxWidth={180}
					/>
				</div>
			}
		</>
	);
};

export default AssetParamInfo;
